import { render, staticRenderFns } from "./AphtEdit.vue?vue&type=template&id=f218ef7a&"
import script from "./AphtEdit.vue?vue&type=script&lang=js&"
export * from "./AphtEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports